import {FunctionComponent} from 'react';
import {Route, Routes} from 'react-router';
import DesignSystem from './design-system';
import Ocr from './ocr';

const Debug: FunctionComponent = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<DesignSystem />} />
        <Route path="/design-system" element={<DesignSystem />} />
        <Route path="/ocr" element={<Ocr />} />
      </Routes>
    </>
  );
};

export default Debug;
